import { EnableWhenWrapperProps } from "@/intake-forms/types/enableWhenWrapper";
import { isEnableWhenSatisfied } from "@/intake-forms/utils/enable-when";

function EnableWhenWrapper<T>({
  form,
  enableWhen,
  children,
  enableWhenBehavior,
  parentPath,
}: EnableWhenWrapperProps<T>) {
  if (
    !isEnableWhenSatisfied({
      enableWhen,
      formValues: form.values as Record<string, unknown>,
      parentPath,
      enableWhenBehavior,
    })
  ) {
    return null;
  }

  return children;
}

export default EnableWhenWrapper;
